export const entitlements = [
  'IDM_Mitarbeiter_ANG',
  'IDM_Mitarbeiter_BW',
  'IDM_Mitarbeiter_CB',
  'IDM_Mitarbeiter_CM',
  'IDM_Mitarbeiter_FuE',
  'IDM_Mitarbeiter_GSW',
  'IDM_Mitarbeiter_HTB',
  'IDM_Mitarbeiter_INF',
  'IDM_Mitarbeiter_ING',
  'IDM_Mitarbeiter_INN',
  'IDM_Mitarbeiter_RZ',
  'IDM_Mitarbeiter_Verwaltung',
  'IDM_Mitarbeiter_WI',
  'IDM_Hiwis_ANG',
  'IDM_Hiwis_BW',
  'IDM_Hiwis_CB',
  'IDM_Hiwis_CM',
  'IDM_Hiwis_FuE',
  'IDM_Hiwis_GSW',
  'IDM_Hiwis_HTB',
  'IDM_Hiwis_INF',
  'IDM_Hiwis_ING',
  'IDM_Hiwis_INN',
  'IDM_Hiwis_RZ',
  'IDM_Hiwis_Verwaltung',
  'IDM_Hiwis_WI',
  'IDM_Professoren_ANG',
  'IDM_Professoren_BW',
  'IDM_Professoren_CB',
  'IDM_Professoren_CM',
  'IDM_Professoren_FuE',
  'IDM_Professoren_GSW',
  'IDM_Professoren_HTB',
  'IDM_Professoren_INF',
  'IDM_Professoren_ING',
  'IDM_Professoren_INN',
  'IDM_Professoren_RZ',
  'IDM_Professoren_Verwaltung',
  'IDM_Professoren_WI',
  'IDM_Lehrbeauftragte_ANG',
  'IDM_Lehrbeauftragte_BW',
  'IDM_Lehrbeauftragte_CB',
  'IDM_Lehrbeauftragte_CM',
  'IDM_Lehrbeauftragte_FuE',
  'IDM_Lehrbeauftragte_GSW',
  'IDM_Lehrbeauftragte_HTB',
  'IDM_Lehrbeauftragte_INF',
  'IDM_Lehrbeauftragte_ING',
  'IDM_Lehrbeauftragte_INN',
  'IDM_Lehrbeauftragte_RZ',
  'IDM_Lehrbeauftragte_Verwaltung',
  'IDM_Lehrbeauftragte_WI',
  'IDM_Professoren_Gesamt',
  'IDM_Lehrbeauftragte_Gesamt',
  'IDM_Mitarbeiter_Gesamt',
  'IDM_Hiwis_Gesamt',
  'IDM_Studenten_Gesamt',
  'IDM_Studenten_AFE-M',
  'IDM_Studenten_BW',
  'IDM_Studenten_BW-M',
  'IDM_Studenten_BWb',
  'IDM_Studenten_EGT',
  'IDM_Studenten_EIT',
  'IDM_Studenten_EIT-M',
  'IDM_Studenten_FF-M',
  'IDM_Studenten_HA',
  'IDM_Studenten_HfA-M',
  'IDM_Studenten_HT',
  'IDM_Studenten_HT-M',
  'IDM_Studenten_HbE-M',
  'IDM_Studenten_IAB',
  'IDM_Studenten_INF',
  'IDM_Studenten_INF-M',
  'IDM_Studenten_ING-M',
  'IDM_Studenten_INN',
  'IDM_Studenten_INN-M',
  'IDM_Studenten_KT',
  'IDM_Studenten_MB',
  'IDM_Studenten_MBA-M',
  'IDM_Studenten_MBb',
  'IDM_Studenten_MEC',
  'IDM_Studenten_MGW',
  'IDM_Studenten_PHY',
  'IDM_Studenten_PT',
  'IDM_Studenten_WI',
  'IDM_Studenten_WI-M',
  'IDM_Studenten_WIF',
  'IDM_Studenten_WMA',
  'IDM_Studenten_PFL',
  'IDM_Studenten_WIb-M',
  'IDM_Studenten_PDK',
  'IDM_Studenten_ARC',
  'IDM_Studenten_BWT',
  'IDM_Studenten_CHE',
  'IDM_Studenten_SOA',
  'IDM_Studenten_IM-M',
  'IDM_Studenten_FI-M',
  'IDM_Studenten_GP-M',
  'IDM_Studenten_BI',
  'IDM_Studenten_CT',
  'IDM_Studenten_APS',
  'IDM_Studenten_IPB',
  'IDM_Studenten_UWT',
  'IDM_Studenten_UFG',
  'IDM_Studenten_PW',
  'IDM_Externe_Extern',
  'IDM_Externe_Gesamt',
  'IDM_Lehrbeauftragte_Inaktiv',
  'IDM_Professoren_Alumni',
  'IDM_UA_Stellenmarkt_Administrator',
  'IDM_UA_International_Office_Incomings_Portal_Administrator',
  'IDM_UA_Dashboard_Administrator',
  'IDM_UA_Career_Center',
  'IDM_UA_Rechenzentrum_Leitung',
  'IDM_UA_HL_Alle',
  'IDM_Abteilung_Studierende_Leitung',
  'IDM_UA_Facility_Management_Administration',
  'IDM_UA_FuE_Administration',
  'IDM_UA_Gremium_QLS_Leitung',
  'IDM_Hochschulkommunikation',
  'IDM_International_Office',
  'IDM_UA_Bibliothek_Leitung_erw',
  'IDM_UA_Zentrale_Studienberatung',
  'IDM_UA_Gremium_StuPa',
  'IDM_UA_Sekretariat_ANG',
  'IDM_UA_Sekretariat_HT',
  'IDM_UA_Sekretariat_BW',
  'IDM_UA_Sekretariat_INF',
  'IDM_Abteilung_Personal',
  'IDM_UA_Team_der_Frauenbeauftragten_Leitung',
  'IDM_UA_Hochschulsport',
  'IDM_UA_HL_Praesidialamt',
  'IDM_UA_Gremium_Personalrat',
  'IDM_UA_Gremium_IKORO',
  'IDM_UA_Beauftragung_Gleichstellung',
  'IDM_UA_Hochschulweite_Veranstaltungsorganisation',
  'IDM_UA_Programmmanagement_AfP',
  'IDM_UA_Sekretariat_CB',
  'IDM_UA_Schreibzentrum',
  'IDM_UA_Familienbuero',
  'rp-ANG-Dashboard-Wahladmin',
  'rp-BW-Dashboard-Wahladmin',
  'rp-ING-Dashboard-Wahladmin',
  'rp-HTB-Dashboard-Wahladmin',
  'rp-IAD-Dashboard-Wahladmin',
  'rp-INF-Dashboard-Wahladmin',
  'rp-WI-Dashboard-Wahladmin',
  'rp-GSW-Dashboard-Wahladmin',
  'rp-CTW-Dashboard-Wahladmin',
  'rp-AFP-Dashboard-Wahladmin',
  'rp-SW-Dashboard-Wahladmin',
  'rp-Gesamt-Dashboard-Wahladmin'
];
